import is from 'is_js';
import React from 'react';
import FadeIn from 'react-fade-in';
import { createUseStyles } from 'react-jss';
import Lottie from 'react-lottie-player';
// import Lottie from "react-lottie";
import { useNavigate } from 'react-router-dom';
// import * as animationErrorData from "../../components/load/error.json";
// import * as animationOfflineData from "../../components/load/off-line.json";
import { useTranslation } from 'react-i18next';
import animationErrorData from '../../components/load/error.json';
import animationOfflineData from '../../components/load/off-line.json';
import { usePageview } from '../../hooks/use-pageview';

function Error() {
  const { t } = useTranslation();
  const classes = useStyles();
  const navigate = useNavigate();

  usePageview('Loading Fail');

  const doRefresh = () => {
    navigate(0);
  };

  return (
    <div className={classes.container}>
      <FadeIn>
        {is.online() ? (
          <div className={classes.animationContainer}>
            <Lottie
              loop={false}
              play
              animationData={animationErrorData}
              style={{ width: 120, height: 120 }}
              // options={errorOptions}
              // height={120}
              // width={120}
            />
            <button
              className={classes.action}
              onClick={doRefresh}
              type="button"
            >
              {t('error.try-again')}
            </button>
          </div>
        ) : (
          <div className={classes.animationContainer}>
            <Lottie
              loop
              play
              animationData={animationOfflineData}
              style={{ width: 300, height: 300 }}
              // options={offlineOptions}
              // height={300}
              // width={300}
            />
            <div className={classes.text} onClick={doRefresh} aria-hidden>
              {t('error.no-internet')}
            </div>
            <button
              className={classes.action}
              onClick={doRefresh}
              type="button"
            >
              {t('error.try-again')}
            </button>
          </div>
        )}
      </FadeIn>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    color: 'white',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    // border: '1px solid yellow',
  },
  animationContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    textAlign: 'center',
    color: '#F7E18A',
    marginTop: -40,
    // border: '1px solid red',
  },
  action: {
    // display: 'inline-block',
    // textAlign: 'center',
    // alignSelf: 'center',
    // justifySelf: 'center',
    color: 'white',
    whiteSpace: 'nowrap',
    textDecoration: 'underline',
    textTransform: 'uppercase',
    marginTop: 60,
    border: 'none',
    background: 'none',
    // border: '1px solid yellow',
  },
  slug: {
    fontWeight: 'bolder',
    color: '#F1934B',
    // textDecoration: 'underline',
  },
});

export { Error };
